export default __webpack_public_path__ + "333956455fda3eeb17e8a0e37dc3ccd1.webp";